'use strict';

/**
 * Buy Online confirmation drawer (PLP tile + Full PDP).
 * SweetAlert2 provides Closing X; panel markup provides Title, Text, Proceed CTA.
 */

var customSwal = require('../utils/customSwal');

(function () {
	if (typeof window !== 'undefined' && window.__lvzBuyOnlineModalInit) {
		return;
	}
	if (typeof window !== 'undefined') {
		window.__lvzBuyOnlineModalInit = true;
	}

	var buyWrapSelector = '.product-tile__buy-online-modal-wrapper';
	var buyOpenSelector = '[data-lvz-buy-online-modal-open="true"]';
	var buyPanelSelector = '[data-lvz-buy-online-modal-panel="true"]';
	var buyProceedSelector = '.product-tile__buy-online-modal-proceed';

	/**
	 * @returns {boolean}
	 */
	function isBuyOnlineMobileLayout() {
		return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767.98px)').matches;
	}

	/**
	 * @param {HTMLButtonElement} triggerBtn
	 * @param {HTMLElement} panelRoot
	 * @param {HTMLElement} returnSlot
	 * @returns {void}
	 */
	function openBuyOnlineModal(triggerBtn, panelRoot, returnSlot) {
		var mobile = isBuyOnlineMobileLayout();
		var titleEl = panelRoot.querySelector('.product-tile__buy-online-modal-title');
		var titleId = titleEl && titleEl.id ? titleEl.id : undefined;
		var opts = {
			html: panelRoot,
			showCloseButton: true,
			closeButtonHtml: '<i class="icon-close sa-right-panel__close-icon" aria-hidden="true"></i>',
			didOpen: function (popup) {
				if (typeof window.$ !== 'undefined' && window.$) {
					window.$('body').trigger('swal:open');
				}
				triggerBtn.setAttribute('aria-expanded', 'true');
				if (popup && titleId) {
					popup.setAttribute('aria-labelledby', titleId);
				}
			},
			didClose: function () {
				if (typeof window.$ !== 'undefined' && window.$) {
					window.$('body').trigger('swal:close');
				}
				if (returnSlot && returnSlot.parentNode && panelRoot) {
					panelRoot.hidden = true;
					returnSlot.parentNode.insertBefore(panelRoot, returnSlot);
					returnSlot.parentNode.removeChild(returnSlot);
				}
				triggerBtn.setAttribute('aria-expanded', 'false');
			},
		};

		if (mobile) {
			Object.assign(opts, {
				position: 'bottom',
				grow: 'row',
				width: '100%',
				showClass: {
					popup: 'sa2-slide-up-in sa2-anim-faster',
				},
				hideClass: {
					popup: 'sa2-slide-down-out sa2-anim-faster',
				},
				customClass: {
					container: 'sa-right-panel-container sa-buy-online-drawer',
					popup: 'sa-right-panel-popup sa-buy-online-drawer__popup',
					htmlContainer: 'sa-right-panel-html sa-buy-online-drawer__html',
				},
			});
		} else {
			opts.customClass = {
				container: 'sa-right-panel-container sa-buy-online-drawer',
				popup: 'sa-right-panel-popup sa-buy-online-drawer__popup sa-buy-online-drawer__popup--desktop',
				htmlContainer: 'sa-right-panel-html sa-buy-online-drawer__html',
			};
		}

		customSwal.Swal.fire(customSwal.rightPanelOptions(opts));
	}

	/**
	 * @param {MouseEvent} ev
	 * @returns {void}
	 */
	function onBuyOnlineClick(ev) {
		var raw = ev.target;
		var target = raw && raw.nodeType === Node.TEXT_NODE ? raw.parentElement : raw;
		if (!target || typeof target.closest !== 'function') {
			return;
		}

		var proceedEl = target.closest(buyProceedSelector);
		if (proceedEl) {
			// Anchors navigate natively; legacy tile markup still exposes the URL on data-href.
			var proceedUrl = proceedEl.tagName === 'A' ? '' : proceedEl.getAttribute('data-href');
			if (proceedUrl) {
				ev.preventDefault();
				window.location.href = proceedUrl;
			}
			return;
		}

		var btn = target.closest(buyOpenSelector);
		if (!btn || !btn.closest(buyWrapSelector)) {
			return;
		}
		var wrap = btn.closest(buyWrapSelector);
		if (!wrap) {
			return;
		}
		var panel = wrap.querySelector(buyPanelSelector);
		if (!panel) {
			return;
		}
		ev.preventDefault();
		if (customSwal.Swal.isVisible()) {
			return;
		}
		var returnSlot = document.createElement('span');
		returnSlot.setAttribute('data-lvz-buy-online-return-slot', 'true');
		returnSlot.hidden = true;
		wrap.insertBefore(returnSlot, panel);
		panel.hidden = false;
		openBuyOnlineModal(btn, panel, returnSlot);
	}

	document.addEventListener('click', onBuyOnlineClick);
})();

module.exports = function () {};
